



















import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import VueClickOutside from 'v-click-outside';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import BuildingManagerData from '@/ts/BuildingManagerData';

@Component({
    directives: {
        clickOutside: VueClickOutside.directive,
    },
})
export default class BuildingManagerSuggestions extends Mixins(DeviceMethods) {
    public searchQuery: string = '';
    public suggestionsReady: boolean = false;
    public currentlyHovered: number | null = null;
    public visible: boolean = false;

    constructor() {
        super();
    }

    get managerSuggestions(): BuildingManagerData[] {
        const returnData: BuildingManagerData[] = [];

        if (!this.dataLoaded) {
            return returnData;
        }

        const baseData = this.$store.getters['Buildings/getManagerSuggestions'];

        for (const id of baseData) {
            returnData.push(this.getManager(id));
        }

        return returnData;
    }

    get dataLoaded(): boolean {
        return (
            this.$store.getters['Buildings/getBuildingProject'] !== null
            && this.$store.getters['Buildings/getManagerSuggestions'] !== null
        );
    }

    public managerHover(index: number) {
        this.currentlyHovered = index;
    }

    public clearHover() {
        this.currentlyHovered = null;
    }

    public hideSuggestions(event: MouseEvent) {
        this.$store.commit(Mutations.HIDE_USER_SUGGESTIONS);
    }

    public selectManager(managerId: number, managerName: string): void {
        this.$store.dispatch(Actions.ADD_MANAGER_TO_BUILDING, managerId);
    }

    public getManager(id: number): BuildingManagerData {
        return this.$store.getters['Buildings/getCacheManager'](id);
    }

    public itemClasses(index: number) {
        return {
            'hococo-manager-suggestion-hover': (index === this.currentlyHovered),
            'hococo-manager-suggestion-adjacent': (
                this.currentlyHovered !== null && index === this.currentlyHovered - 1
            ),
        };
    }

    public closeSuggestion() {
        this.$store.commit(Mutations.HIDE_USER_SUGGESTIONS);
    }

    public created() {
        window.addEventListener('click', this.closeSuggestion);
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeSuggestion);
    }
}
